<template>
  <div class="quick-menu-container">
    <div class="search-wrapper">
      <div class="search-title">快捷功能筛选</div>
      <div class="search-content">
        <el-input v-model="searchForm.name" placeholder="请输入功能名称" class="search-item" clearable @keyup.enter.native="handleSearch" />
        <el-select v-model="searchForm.isShow" class="search-item" placeholder="是否启用" clearable>
          <el-option label="是" value="Y" />
          <el-option label="否" value="N" />
        </el-select>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </div>
    </div>

    <div class="list-wrapper">
      <div class="list-header">
        <div class="list-title">商城快捷功能管理</div>
        <el-button type="primary" @click="handleAdd">新增快捷功能</el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="caId" label="ID" min-width="160" />
        <el-table-column prop="name" label="名称" min-width="120" />
        <el-table-column label="图标" min-width="180">
          <template slot-scope="scope">
            <div class="icon-cell">
              <img v-if="isImageIcon(scope.row.icon)" :src="scope.row.icon" :alt="scope.row.name" class="icon-preview" />
              <span v-else>{{ scope.row.icon }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="seq" label="排序" width="90" />
        <el-table-column prop="url" label="跳转地址" min-width="260" show-overflow-tooltip />
        <el-table-column prop="isShow" label="是否启用" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isShow === 'Y' ? 'success' : 'info'">{{ scope.row.isShow === 'Y' ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>

    <AddQuickMenu :visible.sync="addVisible" @success="getList" />
    <EditQuickMenu :visible.sync="editVisible" :form-data="currentRow" @success="getList" />
    <DelQuickMenu :visible.sync="delVisible" :ca-id="currentRow.caId" @success="getList" />
  </div>
</template>

<script>
import { getQuickMenuList } from '@/api/dev/quickMenuApi'
import AddQuickMenu from '@/components/dev/AddQuickMenu'
import EditQuickMenu from '@/components/dev/EditQuickMenu'
import DelQuickMenu from '@/components/dev/DelQuickMenu'

export default {
  name: 'QuickMenuManageList',
  components: {
    AddQuickMenu,
    EditQuickMenu,
    DelQuickMenu
  },
  data() {
    return {
      loading: false,
      searchForm: {
        name: '',
        isShow: ''
      },
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      addVisible: false,
      editVisible: false,
      delVisible: false,
      currentRow: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const res = await getQuickMenuList({
          page: this.page.current,
          row: this.page.size,
          name: this.searchForm.name,
          isShow: this.searchForm.isShow
        })
        this.tableData = res.data || []
        this.page.total = res.total || 0
      } catch (error) {
        this.$message.error(error.message || '加载快捷功能失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        name: '',
        isShow: ''
      }
      this.page.current = 1
      this.getList()
    },
    handleAdd() {
      this.addVisible = true
    },
    handleEdit(row) {
      this.currentRow = { ...row }
      this.editVisible = true
    },
    handleDelete(row) {
      this.currentRow = { ...row }
      this.delVisible = true
    },
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    isImageIcon(icon) {
      return !!icon && (icon.indexOf('http://') === 0 || icon.indexOf('https://') === 0 || icon.indexOf('/') === 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-menu-container {
  padding: 15px;
  background-color: #f0f2f5;
}

.search-wrapper,
.list-wrapper {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
}

.search-wrapper {
  margin-bottom: 20px;
}

.search-title,
.list-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.search-content {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.search-item {
  width: 240px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.icon-cell {
  display: flex;
  align-items: center;
}

.icon-preview {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>